declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: Record<string, unknown>) => void
    }
  }
}

export function track(event: string, data?: Record<string, unknown>) {
  if (window.umami) {
    window.umami.track(event, data)
  }
}
